import { useAppTheme } from "@hooks/useAppTheme";
import type { BaseItemSchema } from "@memorang/types/src/session/new-session";
import Box from "@memorang/ui/src/components/Box";
import ItemsListItem from "@memorang/ui/src/components/Cards/StudySessionItemsPerformanceCard/ItemsListItem";
import { Text } from "react-native-paper";
type Props = {
	numTotalItems: number;
	localItems: BaseItemSchema[];
	isDetailView?: boolean;
};
const ItemsViewMainContent = ({
	numTotalItems,
	localItems,
	isDetailView,
}: Props) => {
	const theme = useAppTheme();
	return (
		<Box flex={1}>
			<Box
				padding={16}
				borderBottomWidth={1}
				borderBottomColor={theme.colors.divider}
			>
				<Text
					style={{
						color: theme.colors.onSurfaceVariant,
					}}
					variant="labelLarge"
				>
					{numTotalItems} items
				</Text>
			</Box>
			<Box flexGrow={1} paddingBottom={24}>
				{localItems.map((item, index) => (
					<ItemsListItem
						key={`${item.id}-${index}`}
						id={item.id!}
						tags={item.tags!}
						index={index}
						title={item.content?.stem!}
						marked={item.answer?.marked}
						isDetailView={isDetailView}
						answerStatus={
							item.answer?.selectedChoiceIds?.length
								? item.answer?.correct
									? "correct"
									: "incorrect"
								: "skipped"
						}
					/>
				))}
			</Box>
		</Box>
	);
};

export default ItemsViewMainContent;
